<template>
    <div>
        <div class="page-header">
            <div>IMPORT</div>
            <p/>
        </div>
        <div class="header">
            <div class="form__group">
                <label class="label--search">Search</label>
                <Search
                    class="input input__round input--search"
                    placeholder="Search..."
                    @on-value-change="searchValueChanged"
                />
            </div>
            <Button class="btn btn__primary" text="New Import" @on-click="goToCreatePage"/>
        </div>
        <div class="card">
            <table class="has-links" style="width:100%">
                <tr>
                    <SortItem title="CSV ID" @set-sort="setSort" sortKey="id" :sort="sort"/>
                    <SortItem title="Filename" @set-sort="setSort" sortKey="filename" :sort="sort"/>
                    <SortItem
                        title="Number of records"
                        @set-sort="setSort"
                        sortKey="number_of_records"
                        :sort="sort"
                    />
                    <SortItem title="Updated at" @set-sort="setSort" sortKey="updated_at" :sort="sort"/>
                    <SortItem title="Status" @set-sort="setSort" sortKey="status" :sort="sort"/>
                    <SortItem title="Processed at" @set-sort="setSort" sortKey="processed_at" :sort="sort"/>
                    <th class="last-col">Actions</th>
                </tr>
                <tr v-for="currentImport in imports.data" :key="currentImport.id" class="table-row">
                    <td @click="goToDetails(currentImport)">{{currentImport.id}}</td>
                    <td @click="goToDetails(currentImport)">{{currentImport.filename}}</td>
                    <td @click="goToDetails(currentImport)">{{currentImport.number_of_records}}</td>
                    <td
                        @click="goToDetails(currentImport)"
                    >{{moment(currentImport.updated_at).format('DD.MM.YYYY HH:MM')}}
                    </td>
                    <td @click="goToDetails(currentImport)">
                        <Label :status="currentImport.status"/>
                    </td>
                    <td @click="goToDetails(currentImport)">{{currentImport.processed_at}}</td>
                    <td class="last-col">
                        <!--<img-->
                        <!--src="../../assets/download.png"-->
                        <!--style="cursor: pointer; width: 25px;"-->
                        <!--@click="download(e, currentImport.id)"-->
                        <!--&gt;-->
                        <button
                            v-if="currentImport.status == 'in queue' || currentImport.status == 'In queue'"
                            class="process-button"
                            @click="processImport(currentImport.id)"
                        >PROCESS
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <div class="paginate__wrapper" v-if="imports.last_page && imports.last_page > 1">
            <paginate
                :page-count="imports.last_page || 1"
                :prev-text="'Prev'"
                :click-handler="onPageChange"
                :next-text="'Next'"
                :container-class="'paginate'"
            ></paginate>
        </div>
    </div>
</template>

<script>
    import Search from "../partials/Search.vue";
    import Button from "../partials/Button.vue";
    import SortItem from "../partials/SortItem.vue";
    import Paginate from "vuejs-paginate";
    import Label from "../partials/Label";
    import * as api from "./api.js";
    import moment from "moment";

    export default {
        name      : "ImportsList",
        components: {
            Search,
            Button,
            Paginate,
            Label,
            SortItem
        },
        created   : async function () {
            this.fetchImports();
            document.title = "Imports | PayGate Invoice";
        },
        methods   : {
            goToDetails(currentImport) {
                this.$router.push(`imports/${currentImport.id}`);
            },
            processImport     : async function (id) {
                api.processImport(id);
                this.$router.push(`/dashboard/imports/${id}`);
            },
            download          : async function (e, id) {
                let response;
                try {
                    response = await api.downloadImport(id);
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${id}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                } catch (e) {
                    console.log(e);
                }
            },
            goToCreatePage() {
                this.$router.push(`imports/create`);
            },
            searchValueChanged: async function (search) {
                this.search = search;
                this.page = 1;
                this.fetchImports();
            },
            setSort(sort) {
                if (this.sort.value == sort) {
                    if (this.sort.direction == "asc") {
                        this.sort.direction = "desc";
                    } else {
                        this.sort.direction = "asc";
                    }
                } else {
                    this.sort.value = sort;
                    this.sort.direction = "asc";
                }
                this.fetchImports();
            },
            onPageChange      : async function (page) {
                this.page = page;
                this.fetchImports();
            },
            fetchImports      : async function () {
                this.imports = await api.fetchImports({
                    search: this.search,
                    page  : this.page,
                    sort  : this.sort
                });
            }
        },
        data() {
            return {
                page   : 1,
                moment : moment,
                imports: {},
                loading: false,
                sort   : {
                    value    : "created_at",
                    direction: "desc"
                }
            };
        }
    };
</script>

<style lang="scss" scoped>
    .button {
        width: 150px;
    }

    .last-col {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .process-button {
        border: none;
        border-radius: 4px;
        font-family: Montserrat-Light;
        padding: 5px;
        cursor: pointer;
        color: white;
        background-color: #259ad7;
    }

    .header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .customer-id {
        /*padding-left: 50px;*/
    }
</style>
